import { IEntriesListBody } from '@modules/front-office/interface/entries-management';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IEntriesListBody[] = [];

export const FOEntriesManagementSlice = createSlice({
  name: 'foEntriesManagement',
  initialState,
  reducers: {
    setEntriesManagementSlice: (
      _state,
      action: PayloadAction<IEntriesListBody[]>,
    ) => {
      return [...action.payload];
    },
    removeEntriesManagementSlice: () => {
      return initialState;
    },
  },
});

export default FOEntriesManagementSlice.reducer;

export const { setEntriesManagementSlice, removeEntriesManagementSlice } =
  FOEntriesManagementSlice.actions;
